/* ar-ao-page.js: Filter-Chips der Add-on-Seite (A9, 07.10.2026; A11, 07.10.2026). Der Viewer selbst liegt in ar-ao-viewer.js.
   Chips: All, Release week, Profiles. Ein Chip erscheint nur, wenn er etwas filtert: ohne Kachel in seiner Gruppe, oder wenn seine Gruppe alle Kacheln umfasst
   (dann waere er dasselbe wie "All"), faellt er weg. Gibt es nur eine Gruppe, verschwindet die ganze Chip-Reihe. Kein Kauf auf dieser Seite. */
(function () {
  'use strict';
  var doc = document;
  var page = doc.querySelector('[data-ao-page]');
  if (!page) return;
  var chipsWrap = page.querySelector('[data-ao-chips]');
  var chips = Array.prototype.slice.call(page.querySelectorAll('[data-ao-chip]'));
  var tiles = Array.prototype.slice.call(page.querySelectorAll('[data-ao-tile]'));
  var empty = page.querySelector('[data-ao-empty]');

  var visible = 0;
  chips.forEach(function (c) {
    var k = c.getAttribute('data-ao-chip');
    if (k === 'all') return;
    var n = tiles.filter(function (t) { return t.getAttribute('data-cat') === k; }).length;
    c.hidden = n === 0 || n === tiles.length;
    if (!c.hidden) visible++;
  });
  if (visible < 1 || tiles.length < 2) { if (chipsWrap) chipsWrap.hidden = true; return; }

  function pick(key) {
    var shown = 0;
    tiles.forEach(function (t) {
      var on = key === 'all' || t.getAttribute('data-cat') === key;
      t.hidden = !on;
      if (on) shown++;
    });
    chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-ao-chip') === key ? 'true' : 'false'); });
    if (empty) empty.hidden = shown > 0;
  }
  chips.forEach(function (c) { c.addEventListener('click', function () { pick(c.getAttribute('data-ao-chip')); }); });
})();
